import React from 'react';

import { EmptyFieldValueRenderer } from '@/components/molecules/EmptyFieldValueRenderer';
import { FieldValue } from '@/components/molecules/FieldValue';
import { CNPJField, ParagraphField, TextField, ValueType } from '@/types/fields';
import { formatCNPJ } from '@/utility/formatCNPJ';

interface Props {
  readonly value: ValueType;
  readonly field: TextField<unknown> | ParagraphField<unknown> | CNPJField<unknown>;
}

export const CNPJFieldValueRenderer: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value } = props;

  const formattedValue = React.useMemo((): string => formatCNPJ(value), [value]);
  if (typeof value !== 'string') {
    console.debug(`expected a string value for an email field, got: ${value}`);
    return <EmptyFieldValueRenderer />;
  }

  return <FieldValue value={formattedValue} />;
};
